import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./index.scss";
import MappingDataProvider from "./context/mappingDataContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <MappingDataProvider>
      <App />
      {/* <App tenantId="0055d157-940c-4f53-8d1c-0c5e45c0077e" /> */}
    </MappingDataProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.addEventListener("message", (event) => {
  const { type, token } = event.data;
  if (type === "AUTH_TOKEN" && token) {
    localStorage.setItem("svrJwtAccessToken", token); // Store the JWT
  }
});
